// extracted by mini-css-extract-plugin
export default {"infoCell":"h3Arg6ApeZbK9HmNPslj","data":"_gv3Z6iLaSNd5JRhPSiQ","description":"q0L9amYbZV4cTxMDR6Cw"};